import {createReducer} from '@reduxjs/toolkit';
import {selectResult} from '../actions/geocoder.js';

const defaultState = {
  selectedResult: null,
};

export default createReducer(defaultState, builder => {
  builder.addCase(selectResult, (state, {payload}) => {
    state.selectedResult = payload;
  });
});
